// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import { getCurveTypeIdMap } from 'redux/modules/databaseDetails'
import assignEmptyCurveSets from './assignEmptyCurveSets'

const formatRadioCurvePoints = radioCurvePoints => dispatch => {
  // radioCurveSet doesn't know the curveTypeCode
  // create a map to separate the curve data
  // based on each curve point's curve type.
  const curveTypeIdMap = dispatch(getCurveTypeIdMap())

  // creates an empty object of curve types with no curve data.
  // this will look something like:
  // {
  //   'T/I': [],
  //   'MO': [],
  //   ...
  // }
  const curves = Object.values(curveTypeIdMap).reduce((a, curveTypeCode) => ({
    ...a,
    [curveTypeCode]: [],
  }), {})

  // loops over the radioCurveSet and groups the curve points according to their curve type
  radioCurvePoints.forEach(d => {
    const curveTypeCode = curveTypeIdMap[d.curveTypeCodeId]

    curves[curveTypeCode].push({
      curvePoint: castToString(d.curvePoint),
      frequencySep: castToString(d.frequencySep),
      radioCurvePointId: d.radioCurvePointId,
    })
  })

  // if any curve types are empty by this point that means they're not being used.
  // for the UI, just give them each an empty set of 15 points for input fields to render.
  assignEmptyCurveSets(curves)

  return curves
}

export default formatRadioCurvePoints
